import { createI18n } from 'vue-i18n';
import ptBR from '@/locales/pt-br.json';
import esPY from '@/locales/es-py.json';

function getBrowserLocale() {
  const navigatorLang = navigator.language || 
                      navigator.userLanguage || 
                      navigator.browserLanguage || 
                      navigator.systemLanguage || 
                      'pt-BR';
  

  const esVariants = ['es', 'es-ES', 'es-MX', 'es-AR', 'es-CL', 'es-CO', 'es-PE', 'es-VE', 'es-EC', 'es-UY', 'es-PY'];
  
  if (esVariants.some(lang => navigatorLang.startsWith(lang))) {
    console.log('Mapeando para es-PY');
    return 'es-PY';
  }

  if (navigatorLang.startsWith('pt')) {
    return 'pt-BR';
  }

  return 'pt-BR';
}

const i18n = createI18n({
  legacy: false,
  locale: getBrowserLocale(), 
  fallbackLocale: 'pt-BR',
  messages: {
    'pt-BR': ptBR,
    'es-PY': esPY
  }
});

export default i18n;